// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","477":"LogoMakerGuestLazyComponent"}[chunkId] + "." + {"46":"bcfa3871b07f9445876f","477":"bb3d6bd7e171b6f8986e"}[chunkId] + ".js";
};